if(!window.theme._registeredSections['featured-collection'] === true){
  theme.featuredCollection = (function() {
  // Function to kick in Slick slider for mobile
  //  on featured collection product cards.

  // Note: .not('slick-initialized') is to stop
  //  double firing on initialize when resizing.

  let viewItemListDataLayerDelay;
  const handleViewFeaturedCollectionEvent = (sectionId) => {
    const featuredCollectionData = window.theme.featuredCollectionData[sectionId];
    if (!featuredCollectionData) { return; }

    const {items: allResults, itemListId, itemListName, itemListType} = featuredCollectionData;
    let skusComingIntoView = [];

    const viewItemListEvent = (itemList = []) => {
      if (!itemList.length) { return; }
      if (viewItemListDataLayerDelay) {
        clearTimeout(viewItemListDataLayerDelay);
      }

      viewItemListDataLayerDelay = setTimeout(() => {
        let promotionEventView = JSON.parse(localStorage.getItem('ga4-promotionView') || '{}');
        const menuNavigationAction = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
        const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
        window.pushEvent({
          event: 'view_item_list',
          menu_navigation_state: menuNavigationState,
          ecommerce: Object.assign(promotionEventView, {
            items: itemList,
            item_list_id: itemListId,
            item_list_name: itemListName,
            item_list_type: itemListType,
            item_total_count: allResults.length,
            item_visible_count: window.theme.featuredCollectionData[sectionId].itemsVisible.length,
          }),
        }, 'ecommerce');

        skusComingIntoView = [];
      }, 1000);
    };

    const productCards = document.querySelectorAll('.featured-slider .product-card');
    if (productCards.length) {
      productCards.forEach((card) => {
        let isVisibleNow = window.theme.isElementVisibleInViewport(card);
        card.setAttribute('data-visible-by-default', isVisibleNow);
        if (isVisibleNow) {
          skusComingIntoView.push(card.getAttribute('data-sku'));
        }

        const handleIntersection = (entries, observer) => {
          entries.forEach(entry => {
            const visibleByDefault = card.getAttribute('data-visible-by-default') || false;
            isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
            if (entry.intersectionRatio > 0) {
              observer.unobserve(entry.target);

              card.setAttribute('data-visible-in-viewport', isVisibleNow);
              if (isVisibleNow) {
                skusComingIntoView.push(card.getAttribute('data-sku'));
                const itemsInViewport = allResults.filter((item) => skusComingIntoView.includes(item.item_id));
                featuredCollectionData.itemsVisible = featuredCollectionData.itemsVisible || [];
                const visibleItems = itemsInViewport.map((item) => {
                  const itemExists = featuredCollectionData.itemsVisible.find((listItem) => listItem.item_id === item.item_id);
                  const newItem = item;
                  // eslint-disable-next-line no-eval
                  newItem.visible_by_default = visibleByDefault;

                  if (!itemExists) {
                    window.theme.featuredCollectionData[sectionId].itemsVisible.push(newItem);
                  }
                  return newItem;
                });
                viewItemListEvent(visibleItems);
              }
            }
          });
        };
        const observer = new IntersectionObserver(handleIntersection);
        observer.observe(card);
      });
    }
  };

  function featuredCollection(container) {
    // Global Variables
    let isInited = false;
    const slickContainer = $('.featured-slider');
    const isAlways = slickContainer.hasClass('featured-slider--always');

    const sectionId = container ? container.dataset.sectionId : null;

    function onResize() {
      let clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      const isMediumUp = (clientWidth >= Number(theme.settings.grid_medium));
      const isMediumDown = !isMediumUp;

      if (isInited) {
        if (isAlways && isMediumUp) {
          $(slickContainer).slick('slickSetOption', 'slidesToShow', 3, false);
          $(slickContainer).slick('slickSetOption', 'slidesToScroll', 3, true);
        } else if (isAlways && isMediumDown) {
          $(slickContainer).slick('slickSetOption', 'slidesToShow', 2, false);
          $(slickContainer).slick('slickSetOption', 'slidesToScroll', 1, true);
        } else if (isMediumUp) {
          $(slickContainer).slick('unslick');
          isInited = false;
        }
      } else if (isMediumUp && isAlways) {
        $(slickContainer).slick({
          accessibility: false,
          centerMode: true,
          centerPadding: '6%',
          arrows: true,
          dots: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          swipeToSlide: true,
          rows: 0,
        });
        isInited = true;
      } else if (isMediumDown) {
        $(slickContainer).slick({
          accessibility: false,
          centerMode: true,
          centerPadding: '6%',
          arrows: false,
          dots: false,
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          swipeToSlide: true,
          rows: 0,
        });
        isInited = true;
      }

      if (sectionId) {
        handleViewFeaturedCollectionEvent(sectionId);
      }
    }

    window.addEventListener('resize', onResize);
    onResize();
  }

  return featuredCollection;
  })();

  window.theme.sections.register('featured-collection', theme.featuredCollection);
  window.theme._registeredSections['featured-collection'] = true;
}